import Route from '@ember/routing/route';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type SkillsRoute from '../skills';

export default class AuthenticatedCareerPathwaysSkillsIndexRoute extends Route {
  model(): ModelFrom<SkillsRoute> {
    return this.modelFor('authenticated.reimagined.skills') as ModelFrom<SkillsRoute>;
  }
}
